import { render, staticRenderFns } from "./SidebarLabel.vue?vue&type=template&id=b5cfec94&"
import script from "./SidebarLabel.vue?vue&type=script&lang=ts&"
export * from "./SidebarLabel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports